<template>
  <div class="turnstile-container">
    <div ref="turnstileContainer" class="turnstile-widget"></div>
  </div>
</template>

<script>
export default {
  name: 'TurnstileCaptcha',
  props: {
    siteKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      turnstileWidget: null,
      widgetId: null,
      captchaToken: null,
      expiryTimer: null,
    }
  },
  mounted() {
    this.loadTurnstileScript()
  },
  beforeDestroy() {
    this.cleanupTimer()
    // 화면이 이 위젯을 내렸다 다시 그린다(로그인 ↔ 처음 비밀번호 재설정) — 새 위젯은 새 자리에 그려지므로 옛 것은 지운다
    if (this.widgetId != null && window.turnstile) window.turnstile.remove(this.widgetId)
  },
  methods: {
    loadTurnstileScript() {
      // Turnstile 스크립트가 이미 로드되었는지 확인
      if (window.turnstile) {
        this.renderWidget()
        return
      }

      // Turnstile 스크립트 로드
      const script = document.createElement('script')
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
      script.async = true
      script.defer = true

      script.onload = () => {
        this.renderWidget()
      }

      document.head.appendChild(script)
    },
    renderWidget() {
      // 그리기는 붙을 때 한 번이다 — 토큰을 새로 받는 일은 아래 「다시 풀기」가 같은 위젯에서 한다
      this.widgetId = window.turnstile.render(this.$refs.turnstileContainer, {
        sitekey: this.siteKey,
        callback: this.onVerify,
        theme: 'light',
        'expired-callback': this.onExpired,
        'error-callback': this.onError,
      })
    },
    onVerify(token) {
      this.captchaToken = token
      this.$emit('captcha-success', token)

      // 2분 만료 타이머 설정
      this.cleanupTimer()
      this.expiryTimer = setTimeout(() => {
        this.resetWidget()
      }, 120000) // 2분(120초)
    },
    onExpired() {
      this.captchaToken = null
      this.$emit('captcha-expired')
      this.resetWidget()
    },
    onError(error) {
      console.error('Turnstile 오류:', error)
      this.$emit('captcha-error', error)
    },
    /**
     * **토큰을 새로 받는다** — 같은 위젯을 다시 풀게 한다(`turnstile.reset`, 새 토큰은 `callback` 으로 온다). 토큰은 서버가 한 번만
     * 확인하므로(siteverify) 로그인 시도가 실패하면 화면이 이것을 부른다 — 쓴 토큰으로 다시 보내면 「보안 인증」 실패다.
     *
     * 종전에는 여기서 `renderWidget` 을 불렀고 그쪽은 위젯이 있으면 다시 여기를 불러, 2분 만료·만료 콜백 때 서로를 끝없이 불렀다.
     */
    resetWidget() {
      this.cleanupTimer()
      this.captchaToken = null
      if (this.widgetId != null && window.turnstile) window.turnstile.reset(this.widgetId)
    },
    cleanupTimer() {
      if (this.expiryTimer) {
        clearTimeout(this.expiryTimer)
        this.expiryTimer = null
      }
    },
    getToken() {
      return this.captchaToken
    },
  },
}
</script>

<style scoped>
.turnstile-container {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
</style>
